module.exports = __webpack_public_path__ + "img/cand-onboarded.f1feac9d.svg";